<template>
  <div class="mobile-nav">
    <router-link
        class="link home"
        :to="{name: 'pages.home'}"
    >
      Home
    </router-link>

    <router-link
        class="link bookshelf"
        :to="{name: 'pages.books'}"
    >
      Bookshelf
    </router-link>

    <router-link
        class="link bookmarks"
        :to="{name: 'pages.bookmarks'}"
    >
      Bookmarks
    </router-link>

    <router-link
        class="link progress"
        :to="{name: 'pages.progress'}"
    >
      Progress
    </router-link>

    <router-link
        class="link profile"
        :to="{name: 'pages.settings'}"
    >
      Instellingen
    </router-link>
  </div>
</template>

<script>
export default {
  name: "MobileNavigation",
};
</script>
